"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MH = void 0;
exports.MH = {
    belongsToEU: false,
    belongsToEurope: false,
    subdivisions: {
        'MH-L': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-ALL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-EBO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-ENI': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-JAB': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-JAL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-KIL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-KWA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-LAE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-LIB': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-NMK': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-NMU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-RON': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-UJA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-WTH': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-T': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-ALK': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-ARN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-AUR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-LIK': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-MAJ': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-MAL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-MEJ': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-MIL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-UTI': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'MH-WTJ': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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